import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPFullWidthImageAndTextOption from './PDPFullWidthImageAndTextOption';
const PDPFullWidthImageAndTextSelector = t0 => {
  const $ = _c(17);
  const {
    value: t1,
    title: t2,
    onClickAction,
    onHoverAction,
    selectedId
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const value = t3;
  const title = t2 === undefined ? "" : t2;
  let t4;
  if ($[2] !== title) {
    t4 = title ? <div className="PDPFullWidthImageAndTextSelector__title">{title}</div> : null;
    $[2] = title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = value.content;
  const t6 = value.id;
  const t7 = value.sku;
  let t8;
  if ($[4] !== value.value) {
    t8 = value.value.trim();
    $[4] = value.value;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== onClickAction || $[7] !== onHoverAction || $[8] !== selectedId || $[9] !== t8 || $[10] !== value.content || $[11] !== value.id || $[12] !== value.sku) {
    t9 = <PDPFullWidthImageAndTextOption content={t5} onClickAction={onClickAction} onHoverAction={onHoverAction} valueId={t6} sku={t7} optionValueName={t8} selectedId={selectedId} />;
    $[6] = onClickAction;
    $[7] = onHoverAction;
    $[8] = selectedId;
    $[9] = t8;
    $[10] = value.content;
    $[11] = value.id;
    $[12] = value.sku;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t9) {
    t10 = <div className="w-full flex flex-col">{t4}{t9}</div>;
    $[14] = t4;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
PDPFullWidthImageAndTextSelector.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.number,
    content: PropTypes.shape({
      image: PropTypes.string,
      textTitle: PropTypes.string,
      text: PropTypes.string,
      price: PropTypes.string
    })
  }),
  onClickAction: PropTypes.func,
  onHoverAction: PropTypes.func,
  title: PropTypes.string,
  selectedId: PropTypes.number
};
export default PDPFullWidthImageAndTextSelector;